import { WalletAdapterNetwork } from '@solana/wallet-adapter-base';
import { ConnectionProvider, WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
// import { UnsafeBurnerWalletAdapter } from '@solana/wallet-adapter-wallets';
import { clusterApiUrl, PublicKey } from '@solana/web3.js';
import {PhantomWalletAdapter} from '@solana/wallet-adapter-phantom'
import React, { FC, ReactNode, useMemo } from 'react';

require('@solana/wallet-adapter-react-ui/styles.css');

const Wallet = () => {
    return (
        <Context>
            <Content />
        </Context>
    );
};
export default Wallet;

const Context= ({ children }) => {
    // The network can be set to 'devnet', 'testnet', or 'mainnet-beta'.
    const network = WalletAdapterNetwork.Devnet;

    // You can also provide a custom RPC endpoint.
    const endpoint = useMemo(() => clusterApiUrl(network), [network]);

    const wallets = useMemo(
        () => [
            
            new PhantomWalletAdapter(),
        ],
        [network]
    );

    console.log(wallets)
    // console.log('Key ',wallets[0]?.publicKey)
    // if(wallets.length>0 && wallets[0]._publicKey){
        
    //     //  const key = new PublicKey(wallets[0])
    // }
   

    


    return (
        <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets} autoConnect>
                <WalletModalProvider>{children}</WalletModalProvider>
            </WalletProvider>
        </ConnectionProvider>
    );
};

const Content = () => {
    return (
        <div className="wallet">
            <WalletMultiButton />
        </div>
    );
};
